import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Building2, Palette } from "lucide-react";
import TraegerProfileEditor from "@/components/TraegerProfileEditor";
import MeasureApprovalsTab from "@/components/MeasureApprovalsTab";
import CcSettingsTab from "@/components/CcSettingsTab";
import TraegerStammdatenTab from "@/components/TraegerStammdatenTab";
import TraegerTemplatesTab from "@/components/TraegerTemplatesTab";
import TraegerSealsTab from "@/components/TraegerSealsTab";
import TraegerGoalsTab from "@/components/TraegerGoalsTab";
import TarifTab from "@/components/TarifTab";
import WhatsAppTab from "@/components/WhatsAppTab";

export const TRAEGER_TABS = [
  ["stammdaten", "Stammdaten"], ["adresse", "Adresse und Kontakt"], ["brand", "Brand Identity"], ["vorlagen", "Vorlagen"],
  ["signatur", "Signatur"], ["siegel", "Zertifizierungssiegel"], ["ziele", "Ziele"], ["zulassungen", "Maßnahmen-Zulassungen"], ["cc", "CC-Mitarbeiter"],
  ["whatsapp", "WhatsApp"], ["tarif", "Tarif & Zugriffe"],
];

function Brand() {
  return (
    <div className="space-y-4">
      <div className="border border-slate-200 bg-white p-5 flex items-center gap-4 flex-wrap">
        <Palette size={20} className="text-[#0a788c]" />
        <div className="flex-1 min-w-0"><div className="text-sm font-medium text-slate-900">Branding Studio</div><div className="text-xs text-slate-500">Markenfarben, Schriften und Login-Hintergrund mit Live-Vorschau pflegen.</div></div>
        <Link to="/branding" className="px-4 py-2 text-xs font-medium bg-slate-900 text-white hover:bg-black" data-testid="traeger-open-studio">Studio öffnen</Link>
      </div>
      <TraegerProfileEditor show="images" onlyImages={["logo"]} />
    </div>
  );
}

export default function TraegerPage() {
  const [params, setParams] = useSearchParams();
  const tab = TRAEGER_TABS.some(([k]) => k === params.get("tab")) ? params.get("tab") : "stammdaten";
  return (
    <div className="max-w-6xl mx-auto p-4 sm:p-8" data-testid="traeger-page">
      <div className="text-[10px] font-bold uppercase tracking-overline text-slate-500 mb-1 flex items-center gap-1.5"><Building2 size={12} /> Zentrale Konfiguration</div>
      <h1 className="font-heading text-3xl font-light tracking-tighter text-slate-900 mb-6">Träger</h1>
      <div className="flex flex-wrap gap-x-1 border-b border-slate-200 mb-6" data-testid="traeger-tabs">
        {TRAEGER_TABS.map(([k, l]) => (
          <button key={k} onClick={() => setParams({ tab: k })} data-testid={`traeger-tab-${k}`}
            className={`px-4 py-2 text-sm -mb-px border-b-2 whitespace-nowrap transition-colors ${tab === k ? "border-slate-900 text-slate-900 font-medium" : "border-transparent text-slate-500 hover:text-slate-800"}`}>{l}</button>
        ))}
      </div>
      {tab === "stammdaten" && <TraegerStammdatenTab />}
      {tab === "adresse" && <TraegerProfileEditor show="fields" />}
      {tab === "brand" && <Brand />}
      {tab === "vorlagen" && <TraegerTemplatesTab />}
      {tab === "signatur" && <TraegerProfileEditor show="images" onlyImages={["stamp", "signature"]} />}
      {tab === "siegel" && <TraegerSealsTab />}
      {tab === "ziele" && <TraegerGoalsTab />}
      {tab === "zulassungen" && <MeasureApprovalsTab />}
      {tab === "cc" && <CcSettingsTab />}
      {tab === "tarif" && <TarifTab />}
      {tab === "whatsapp" && <WhatsAppTab />}
    </div>
  );
}
